<div class="modal-backdrop">
  <div class="modal-content">
    <div class="modal-header">
      <h2 class="modal-title">{{ AddExceptionLabels.modalTitle }}</h2>
      <button class="close-btn" (click)="onClose()">×</button>
    </div>
    <form [formGroup]="exceptionForm" class="modal-body">
      <div class="modal-column">
        <emerald-dropdown
          [label]="AddExceptionLabels.resourceLabel"
          [outlined]="resourceDropdownOutlined"
          [options]="resourceDropdownOptions"
          [preSelectedValue]="resourceDropdownPreSelectedValue"
          [preSelectedLabel]="resourceDropdownPreSelectedLabel"
          [formControlName]="'resource'"
          [showFilter]="true"
        ></emerald-dropdown>
      </div>
      <div class="modal-column">
        <label>Exception Duration</label>
        <div class="calendar-wrapper">
          <mat-form-field appearance="fill" class="no-border-form-field">
            <mat-date-range-input [rangePicker]="picker" [formGroup]="exceptionForm">
              <input matStartDate formControlName="startDate" placeholder="Start Date" />
              <input matEndDate formControlName="endDate" placeholder="End Date" />
            </mat-date-range-input>
            <mat-datepicker-toggle
              matIconSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-date-range-picker #picker [startAt]="calendarStartDate"></mat-date-range-picker>
          </mat-form-field>
        </div>
      </div>
      <div class="modal-column">
        <label for="comment-input">{{ AddExceptionLabels.commentsText }}</label>
        <textarea
          id="comment"
          class="emerald-textarea"
          rows="3"
          formControlName="comment"
          [placeholder]="AddExceptionLabels.commentsText"
        ></textarea>
        <div class="help-text">
          {{ AddExceptionLabels.helpText }}
        </div>
      </div>
    </form>
    <div class="modal-actions">
      <emerald-button
        [type]="'Secondary'"
        [label]="AddExceptionLabels.cancelLabel"
        (onClick)="onClose()"
      ></emerald-button>
      <emerald-button
        [label]="isSubmitting ? 'Submitting...' : AddExceptionLabels.submitLabel"
        [disabled]="isSubmitting"
        (onClick)="onSubmit()"
      ></emerald-button>
    </div>
  </div>
</div>
